import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import React from 'react'

const options = [{
  type: 'permanent-access',
  icon: 'infinity'
}, {
  type: 'time-access',
  icon: 'clock'
}, {
  type: 'one-time-access',
  icon: 'oneTimeAccess'
}]

interface SelectAccessTypePopupProps {
  selectType: (type: string) => void
}

const SelectAccessTypePopup: React.FC<SelectAccessTypePopupProps> = ({ selectType }) => {
  const { t } = useTranslation('warehouse')
  return (
    <Popup>
      <div className='popup__selectAccessType'>
        <div className='popup__title'>
          <div>{t(`shareMag.${process.env.REACT_APP_TYPE}`)}</div>
          <div>{t('whatTypeOfAccessDoYouWantToAdd')}</div>
        </div>
        <div className='popup__selectAccessType__options'>
          {options.map(({ type, icon }) => <div
            key={type}
            className='popup__selectAccessType__option'
            onClick={() => {
              selectType(type)
            }}>
            <div className='group'>
              <i className={`icon icon--${icon} s30`} />
              <div className='popup__selectAccessType__option__arrow center'>
                <i className='icon icon--arrow-right' />
              </div>
            </div>
            <div className='popup__selectAccessType__option__desc --secFont'>{t(type)}</div>
          </div>)}
        </div>
      </div>
    </Popup>
  )
}

export default SelectAccessTypePopup